(() => {
  if (window.diggnPdpOrderLayoutSubscribed) return;
  window.diggnPdpOrderLayoutSubscribed = true;

  const dispatchDates = document.querySelectorAll('[data-dg-order-layout]:not(quick-add-modal *) [data-dg-dispatch-date]');

  function updateDispatchDates() {
    // Saudi Standard Time is UTC+3. Use UTC date methods on the shifted clock.
    const saudiClock = new Date(Date.now() + 3 * 60 * 60 * 1000);
    const nextMidnight = Date.UTC(saudiClock.getUTCFullYear(), saudiClock.getUTCMonth(), saudiClock.getUTCDate() + 1);
    const dispatch = new Date(nextMidnight);
    if (dispatch.getUTCDay() === 5) dispatch.setUTCDate(dispatch.getUTCDate() + 1);

    for (const date of dispatchDates) {
      const format = new Intl.DateTimeFormat(date.lang, {
        calendar: 'gregory', timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric',
      });
      date.dateTime = dispatch.toISOString().slice(0, 10);
      date.textContent = format.format(dispatch);
    }

    window.setTimeout(updateDispatchDates, nextMidnight - saudiClock.getTime());
  }

  if (dispatchDates.length) updateDispatchDates();

  const reviewEndpoint = 'https://diggnitcustomersupport.floot.app/_api/reviews/storefront/list';
  const isEligible = (review) =>
    review?.verifiedBuyer === true && review.rating >= 4 &&
    review.ratingOnly === false && review.disclosure === null && Boolean(review.title || review.body);

  async function confirmQuote(figure) {
    const params = new URLSearchParams({
      disclosureVersion: 'owned-review-v1',
      productId: figure.dataset.productId,
      language: figure.dataset.reviewLanguage,
      locale: document.documentElement.lang,
      sort: 'oldest',
      limit: '8',
    });
    const reviewers = [];
    const signal = AbortSignal.timeout(8000);
    const expectedPage = Number(figure.dataset.reviewPage);
    if (!Number.isSafeInteger(expectedPage) || expectedPage < 1) return;

    for (const page of [expectedPage, expectedPage - 1, expectedPage + 1]) {
      if (page < 1) continue;
      params.set('page', String(page));
      const response = await fetch(`${reviewEndpoint}?${params}`, { signal });
      if (!response.ok) return;
      const { json: result } = await response.json();
      if (!Array.isArray(result?.reviews)) return;
      const eligible = result.reviews.filter(isEligible);
      reviewers.push(...eligible);
      const selected = eligible.find((review) => String(review.id) === figure.dataset.reviewId);

      if (selected) {
        const initials = figure.closest('[data-dg-order-proof]').querySelector('[data-dg-order-initials]');
        const seen = new Set();
        for (const review of [selected, ...reviewers]) {
          const name = review.authorName?.trim();
          if (!name || seen.has(name.toLowerCase())) continue;
          const letters = name.split(/\s+/).slice(0, 2).map((part) => part.match(/\p{L}/u)?.[0] || '').join('');
          if (!letters) continue;
          seen.add(name.toLowerCase());
          const badge = document.createElement('span');
          badge.textContent = letters.toUpperCase();
          initials.append(badge);
          if (seen.size === 3) break;
        }
        initials.hidden = !initials.childElementCount;
        figure.hidden = false;
        return;
      }
      if (page === expectedPage && expectedPage === 1 && !result.hasMore) return;
    }
  }

  for (const section of document.querySelectorAll('[data-dg-order-layout]:not(quick-add-modal *)')) {
    section.setAttribute('data-dg-order-ready', '');
    for (const element of section.querySelectorAll('.dg-order-price, .dg-order-guarantee, .dg-order-shipping, .dg-order-proof')) {
      element.hidden = false;
    }
    const quote = section.querySelector('[data-dg-order-quote]');
    if (quote) confirmQuote(quote).catch(() => {});
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data?.sectionId || !data.html) return;
    const section = document.getElementById(`MainProduct-${data.sectionId}`);
    if (!section?.hasAttribute('data-dg-order-layout') || section.closest('quick-add-modal')) return;

    const current = section.querySelector('[data-dg-order-price]');
    const next = data.html.getElementById(`MainProduct-${data.sectionId}`);
    const nextPrice = next?.querySelector('[data-dg-order-price]');
    if (!current) return;

    if (!nextPrice || nextPrice.dataset.variant !== String(data.variant?.id)) {
      current.hidden = true;
    } else {
      current.replaceChildren(...Array.from(nextPrice.childNodes, (node) => node.cloneNode(true)));
      current.dataset.variant = nextPrice.dataset.variant;
      current.hidden = false;
    }

    const shipping = section.querySelector('[data-dg-order-shipping]');
    if (shipping) shipping.hidden = !next?.querySelector('[data-dg-order-shipping]');
  });
})();
